import { usePrivy } from "@privy-io/react-auth";
import { Header } from "components/Header";
import { Outlet } from "react-router-dom";
import { AuthButton } from "./AuthButton";
import { useUserStore } from "stores/user";
import { useEffect } from "react";
import { userService } from "services/userService";
import { EUserRole } from "types/user";

export const Layout = () => {
  const { user, ready } = usePrivy();
  const { isUserDataLoading, userData } = useUserStore();
  const isAuthorized = user && userData?.role === EUserRole.ADMIN;

  const isLoading = !ready || isUserDataLoading;

  useEffect(() => {
    if (user) {
      userService.getUser();
    }
  }, [user]);

  useEffect(() => {
    if (user && !userData) {
      userService.registerUser();
    }
  }, [user, userData]);

  return (
    <div className="h-full  flex flex-col">
      <Header />

      <main className="h-full">
        {!isLoading ? (
          <>
            {isAuthorized ? <Outlet /> : (
              <div className="flex justify-center items-center h-full">
                <AuthButton />
              </div>
            )}
          </>
        ) : (<div className="flex justify-center items-center h-full">Loading...</div>)}
      </main>
    </div>
  );
};
